import request from '../utils/request';

// 平台代售物流信息 API
export const platformSalesShippingApi = {
  // 分页查询平台代售物流信息列表
  // params: { page, size, orderId }
  getPlatformSalesShippingList: (params) => request.get('/platform-sales-shipping', { params }),
  
  // 获取平台代售物流信息详情
  getPlatformSalesShippingDetail: (id) => request.get(`/platform-sales-shipping/${id}`),
  
  // 创建平台代售物流信息
  createPlatformSalesShipping: (data) => request.post('/platform-sales-shipping', data),
  
  // 更新平台代售物流信息
  updatePlatformSalesShipping: (id, data) => request.put(`/platform-sales-shipping/${id}`, data),
  
  // 删除平台代售物流信息
  deletePlatformSalesShipping: (id) => request.delete(`/platform-sales-shipping/${id}`),
  
  // 根据订单ID查询物流信息
  getShippingByOrderId: (orderId) => request.get(`/platform-sales-shipping/order/${orderId}`)
};

